var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterAssistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7969 39.6889H16.3978V0L32.7969 39.6889Z",
    fill: "url(#paint0_linear_1133_12331)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 39.6889H16.3978V0L0 39.6889Z",
    fill: "url(#paint1_linear_1133_12331)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18841 19.8691L14.0792 27.6259L10.5785 30.6222H3.74573L8.18841 19.8691Z",
    fill: "url(#paint2_linear_1133_12331)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3978 30.6223L14.0792 27.626L10.5785 30.6223H16.3978Z",
    fill: "url(#paint3_linear_1133_12331)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0619 34.4887L0 39.6887L3.74575 30.6221L6.0619 34.4887Z",
    fill: "url(#paint4_linear_1133_12331)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74573 30.6221L6.06188 34.4887L10.5785 30.6221H3.74573Z",
    fill: "url(#paint5_linear_1133_12331)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.6888L6.87336 35.8394L6.0619 34.4888L0 39.6888Z",
    fill: "url(#paint6_linear_1133_12331)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5785 30.6221H16.3978L6.87334 35.8394L6.06189 34.4887L10.5785 30.6221Z",
    fill: "url(#paint7_linear_1133_12331)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3979 30.6221L10.8605 39.6887L6.87341 35.8394L16.3979 30.6221Z",
    fill: "url(#paint8_linear_1133_12331)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.6887H10.8604L6.87336 35.8394L0 39.6887Z",
    fill: "url(#paint9_linear_1133_12331)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3978 30.6221L16.9076 30.9159L10.8605 39.6887L16.3978 30.6221Z",
    fill: "#90793F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9076 30.916L20.726 39.6889H10.8605L16.9076 30.916Z",
    fill: "url(#paint10_linear_1133_12331)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2857 35.5407L20.726 39.6889L16.9076 30.916L25.2857 35.5407Z",
    fill: "url(#paint11_linear_1133_12331)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2856 35.5405L32.7968 39.6887H20.726L25.2856 35.5405Z",
    fill: "url(#paint12_linear_1133_12331)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3978 30.6221L19.9404 28.7271L24.1147 32.2851L23.2847 34.4345L16.3978 30.6221Z",
    fill: "url(#paint13_linear_1133_12331)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1146 32.2852L32.7968 39.6889L23.2847 34.4345L24.1146 32.2852Z",
    fill: "url(#paint14_linear_1133_12331)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3978 30.6224L14.0792 27.6261L16.4077 25.6372L16.3978 30.6224Z",
    fill: "#B1995A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9404 28.727L26.7473 25.0566L24.1147 32.285L19.9404 28.727Z",
    fill: "url(#paint15_linear_1133_12331)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7472 25.0566L32.7968 39.6887L24.1146 32.285L26.7472 25.0566Z",
    fill: "url(#paint16_linear_1133_12331)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3978 30.6224L19.9404 28.7273L16.4077 25.6372L16.3978 30.6224Z",
    fill: "url(#paint17_linear_1133_12331)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7415 20.2001L23.2366 18.9668L16.4076 25.6384L17.3446 26.4569L22.7896 21.1285L28.2149 34.2643L29.3527 33.7915L23.7415 20.2001Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06388 20.1901L9.5675 18.9556L16.4076 25.6383L15.4644 26.4408L10.0145 21.1185L4.59041 34.2531L3.45142 33.7815L9.06388 20.1901Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3991 24.358L9.92468 18.0926L16.3991 2.43457L22.8747 18.0901L16.3991 24.358Z",
    fill: "#CCAD6D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3978 24.3531L16.3991 2.43457L22.8747 18.0901L16.3978 24.3531Z",
    fill: "#BB9B5D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6098 11.0073H17.2315L19.8431 17.8937L20.5302 17.9814V18.637H16.8842V17.9814L17.6489 17.9258L17.7363 17.7765L17.1428 16.095H14.7454L14.179 17.7653L14.2947 17.9036L15.015 17.9802V18.6357H12.2987V17.9802L13.0301 17.9357L15.6098 11.0073ZM15.9065 12.8431L15.0163 15.3407H16.814L15.9065 12.8431Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1133_12331",
    x1: 16.3984,
    y1: 19.8444,
    x2: 32.7969,
    y2: 19.8444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3A15F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1133_12331",
    x1: 7.71881,
    y1: 19.8444,
    x2: 17.008,
    y2: 19.8444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE69A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1133_12331",
    x1: 2.41492,
    y1: 25.2123,
    x2: 11.5914,
    y2: 25.2883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B26B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1133_12331",
    x1: 15.3698,
    y1: 29.2196,
    x2: 4.51733,
    y2: 27.9359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B7F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D8443"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1133_12331",
    x1: 1.03172,
    y1: 35.1556,
    x2: 6.44888,
    y2: 35.1556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC9F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8A86A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1133_12331",
    x1: 3.74602,
    y1: 32.5558,
    x2: 10.5786,
    y2: 32.5558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEC47E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1133_12331",
    x1: 0,
    y1: 37.0888,
    x2: 6.87285,
    y2: 37.0888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A6D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94773B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1133_12331",
    x1: 6.06129,
    y1: 33.2309,
    x2: 16.3983,
    y2: 33.2309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92763A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1995A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1133_12331",
    x1: 6.87291,
    y1: 35.1556,
    x2: 16.3984,
    y2: 35.1556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94773B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B49D60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1133_12331",
    x1: 0,
    y1: 37.7639,
    x2: 10.8604,
    y2: 37.7639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#866930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91783E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1133_12331",
    x1: 15.7929,
    y1: 39.666,
    x2: 15.7929,
    y2: 37.4717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C813D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0843D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1133_12331",
    x1: 16.9072,
    y1: 35.3021,
    x2: 25.286,
    y2: 35.3021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#897344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#816B3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1133_12331",
    x1: 20.7253,
    y1: 37.6142,
    x2: 32.7968,
    y2: 37.6142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1133_12331",
    x1: 16.3984,
    y1: 31.581,
    x2: 24.1149,
    y2: 31.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0934B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C8344"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1133_12331",
    x1: 23.2852,
    y1: 35.9868,
    x2: 32.7968,
    y2: 35.9868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87703A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E5523"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1133_12331",
    x1: 20.0325,
    y1: 28.6708,
    x2: 26.8396,
    y2: 28.6708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4B574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD9C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1133_12331",
    x1: 24.1149,
    y1: 32.3727,
    x2: 32.7968,
    y2: 32.3727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC9D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2904C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1133_12331",
    x1: 16.3984,
    y1: 28.1299,
    x2: 19.9402,
    y2: 28.1299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0944C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA8E46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterAssistant);
export default __webpack_public_path__ + "static/media/MasterAssistant.d97f0ac51f7a508aaaf35ac57a931a45.svg";
export { ForwardRef as ReactComponent };